import { render, staticRenderFns } from "./ChooseOrderNew.vue?vue&type=template&id=2a16ad03&scoped=true&"
import script from "./ChooseOrderNew.vue?vue&type=script&lang=js&"
export * from "./ChooseOrderNew.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrderNew.vue?vue&type=style&index=0&id=2a16ad03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a16ad03",
  null
  
)

export default component.exports